/**
 * This function coerces a string into a string literal type.
 * Using tagged union types in TypeScript 2.0, this enables
 * powerful typechecking of our reducers.
 *
 * Since every action label passes through this function it
 * is a good place to ensure all of our action labels
 * are unique.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var typeCache = {};
export function type(label) {
    if (typeCache[label]) {
        throw new Error("Action type \"" + label + "\" is not unique\"");
    }
    typeCache[label] = true;
    return label;
}
var ImmutableArrayUtils = /** @class */ (function () {
    function ImmutableArrayUtils() {
    }
    ImmutableArrayUtils.insertItem = function (array, item) {
        var newArray = array.slice();
        newArray.splice(array.length, 0, item);
        return newArray;
    };
    ImmutableArrayUtils.insertItemInBeginning = function (array, item) {
        return [item].concat(array);
    };
    ImmutableArrayUtils.removeItem = function (array, item) {
        return array.filter(function (it) { return !Object.is(it, item); });
    };
    ImmutableArrayUtils.updateItem = function (array, item) {
        if (array.length === 0) {
            return [item];
        }
        return array.map(function (it) { return !Object.is(it, item) ? it : __assign({}, item); });
    };
    return ImmutableArrayUtils;
}());
export { ImmutableArrayUtils };
